export * from './zeit-arts-list.component';
export * from './zeit-arts-list.component.module';